// The part GLBs under public/art/parts/, by name: no three import, so a spec can be
// checked against them in Node.

// Small forge parts (tools/parts/build_parts.py) — a few hundred KB total,
// used by every spec hull: preloaded at boot.
export const FORGE_PARTS = [
  'thruster-bell', 'truss-segment', 'docking-collar', 'sensor-mast',
  'rcs-quad', 'radiator-hinge', 'antenna-farm', 'grapple-arm', 'fuel-manifold',
  // assembly-scale parts (Grammar round 2): compose masses, don't sculpt them
  'prow-wedge', 'tank-ring', 'thrust-frame', 'vls-deck', 'saddle-tank', 'padeye',
  // the PDC deep-focus assembly (jointed; origins at pivots — real DOF)
  'pdc-base', 'pdc-arm', 'pdc-cradle', 'pdc-gun',
  // the hatch family (deep-focus round 2): cargo/service/crew
  'hatch-cargo', 'hatch-service', 'hatch-crew',
  // the radiator family (deep-focus round 3) — ASSEMBLY-GRAMMAR §3C.
  // rad-panel carries a 'heat' vertex colour (root-hot → tip-cool); the
  // composed wings live in HULL_PARTS because they are 19k faces.
  'rad-root', 'rad-boom', 'rad-panel',
] as const;
// Whole authored hulls (tools/parts/ingest_hull.py) — 4–16 MB each —
// plus composed SUB-ASSEMBLIES (our own forged parts, pre-assembled + posed).
// NEVER preloaded: they stream in on the first instancePart() that needs them
// (the loader cache makes every later instance instant).
export const HULL_PARTS = ['kb-battlecruiser', 'kb-cargoship', 'kb-comms-station', 'pup-hull', 'pup-radiator', 'pdc-assembly',
  // the authored frigates (tools/parts/hulls/), one of them the player's ship
  'custos-tower', 'cannibal-heavy', 'spine-truss', 'lance',
  // radiator wings, one GLB per deployment state — the posture tell is a
  // model swap, not a rig: stowed for combat, extended for a hot reactor
  'radiator-wing', 'radiator-wing-deploying', 'radiator-wing-stowed'] as const;
export const PART_NAMES = [...FORGE_PARTS, ...HULL_PARTS] as const;
export type PartName = (typeof PART_NAMES)[number];
